/**
 * Widget to insert locale specific text where the element for this widget previously existed
 * Do not modify this widget's DOM output. It will change the DOM structure which will potentially break styling.
 */
import locale from "common/managers/locale";

const Locale = kendo.ui.Widget.extend({

    options: {
        name: "Locale",
        key: "",
        value: "",
        bind: false
    },

    init: function(element, options) {

        var val = "";
        if (options.value !== undefined) {
            var nested = locale.get(options.value);
            if (nested === undefined) {
                nested = options.value;
            }
            val = locale.get(options.key, nested);
        } else {
            val = locale.get(options.key);
        }

        if (options.bind) {
            kendo.ui.Widget.fn.init.apply(this, arguments);
            this.element.text(val);
            this.wrapper = this.element;
            return;
        }

        $(element).replaceWith(val);
    },

    value: function(val) {
        if (val !== undefined) {
            this.element.text(locale.get(this.options.key, val));
        }
    }

});

kendo.ui.plugin(Locale);
export default Locale;
